import Axios from './baseApi';

export default {
  fetch(query) {
    let url = '/api-master-data/v1/pigSty';
    if(query) {
      url = `${url}?query=${query}`;
    }
    return Axios.get(url);
  },
  fetchById(id) {
    return Axios.get(`/api-master-data/v1/pigSty/${id}`);
  },
  fetchByFactoryId(factory) {
    return Axios.get(`/api-master-data/v1/pigSty/by-factory/${factory}`);
  },
  fetchDetails() {
    return Axios.get('/api-master-data/v1/factory/factory/details');
  },
  async update(data) {
    return await Axios.post(`/api-master-data/v1/pigSty`, data);
  },
  async create(data) {
    return await Axios.put(`/api-master-data/v1/pigSty`, data);
  },
  async delete(pigStyId) {
    return await Axios.delete(`/api-master-data/v1/pigSty/${pigStyId}`);
  }
}
